import styled from 'styled-components';
import { MainHead } from '../../../components/common/head/MainHead';
import { AnimateLoading } from '../../../components/common/loading/AnimateLoading';
import { useGetNoticesQuery } from '../../../hooks/api/notice/queries/useGetNotices.query';
import { useLayout } from '../../../hooks/screen/useLayout';
import { Collapse } from 'antd';
import { INotice } from '../../../interfaces/Notice.interfaces';
import { formatDate } from '../../../utils/formatter/formatDate.util';

export const NoticePage = () => {
  useLayout({
    fixedHeader: <MainHead backButton={{ isShow: true }} />,
    fixedHeaderHeight: 40,
  });

  const { data: notices, isLoading: isGetNoticesQueryLoading } = useGetNoticesQuery();
  const panelStyle: React.CSSProperties = {
    marginBottom: 8,
    background: '#F2F2F7',
    borderRadius: '8px',
    border: 'none',
  };
  const getAccordionItems = (notices: INotice[]) => {
    const result = notices.map((notice: INotice) => {
      return {
        key: notice.id,
        label: (
          <>
            <CreateDate>{formatDate(notice.createdAt)}</CreateDate>
            <Title>{notice.title}</Title>
          </>
        ),
        children: <Content>{notice.content}</Content>,
        style: panelStyle,
      };
    });
    return result;
  };

  if (isGetNoticesQueryLoading) {
    return <AnimateLoading />;
  }

  if (notices && notices.length > 0) {
    return (
      <Container>
        <Collapse
          bordered={false}
          defaultActiveKey={notices[0].id}
          expandIconPosition={'end'}
          style={{ background: '#fff', width: '100%' }}
          items={getAccordionItems(notices)}
        />
      </Container>
    );
  }

  return <></>;
};

const Container = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;

  gap: 20px;

  padding: 20px 10px;
`;

const CreateDate = styled.span`
  color: var(--Light-Scheme-Monochrome-grey100, #858894);

  /* Display/Small/s-regular */
  font-family: Pretendard;
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: 130%; /* 15.6px */
`;

const Title = styled.h2`
  width: 100%;

  display: flex;
  justify-content: flex-start;
  align-items: center;

  color: var(--Light-Scheme-Monochrome-black, #232429);
  text-overflow: ellipsis;

  /* Display/Large/l-medium */
  font-family: Pretendard;
  font-size: 16px;
  font-style: normal;
  font-weight: 500;
  line-height: 130%; /* 20.8px */

  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
  word-wrap: break-word;
`;

const Content = styled.p`
  white-space: pre-line;
  color: var(--Light-Scheme-Monochrome-offblack, #505363);

  /* Body/Large/l-light */
  font-family: Pretendard;
  font-size: 16px;
  font-style: normal;
  font-weight: 300;
  line-height: 150%; /* 24px */
`;
